export const Actions = {
    ACCEPT: 'ACCEPT',
    DECLINE: 'DECLINE',
    DELETE: 'DELETE',
    ACCEPT_SMS: 'ACCEPT_SMS'
}



// WEBPACK FOOTER //
// ./src/constants/components/AcceptDialog.ts